import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for updating a space which is currently in the staging area.
 */
type ConfluenceUpdateSpaceData = {
	/**
	 * The string representation of a space
	 */
	jsonSpace: string;
};

/**
 * Properties for the Confluence space creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceUpdateSpaceCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the space update request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the updated space.
	 */
	data: ConfluenceUpdateSpaceData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to update a space which is currently in the staging area.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update a staging space with the specified content.
 */
export const ConfluenceSpaceUpdateCommand: CommandConstructor<
	ConfluenceUpdateSpaceCommandProperties,
	SerializableValue
> = createCommand<ConfluenceUpdateSpaceCommandProperties>('confluence-space-update-command');
